<div class="col-12 assessor-search-client">
  <div class="row header-search" *ngIf="!loading">
    <div class="col-12">
      <div class="row">
        <div class="col-1 search-icon">
          <mat-icon svgIcon="search"></mat-icon>
        </div>
        <div class="col-10">
          <div>
            <mat-form-field [floatLabel]="'never'" [ngClass]="{'input-invalid' : !hiddenInvalid}">
              <input spellcheck="false" (blur)="callBackWorksheet()" minlength="1" maxlength="60" matInput #autoInput
                type="text" class="active" (keyup)="onAutoCompletAsset($event)" [(value)]="nameAutoComplete"
                [placeholder]="'Digite o nome ou a conta do seu cliente'" (keydown.enter)="onInputEnter($event)" ondragstart="return false;"
                ondrop="return false;" appAutosizeInput [minWidth]="80" [maxWidth]="36"
                [autoSizeActive]="autoSizeActive">
            </mat-form-field>
          </div>
        </div>
        <div class="col-1 icons">
          <mat-icon svgIcon="close" (click)="closeDialog()"></mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="row content">
    <div class="col-12 spinner" *ngIf="loading">
      <app-spinner-loading></app-spinner-loading>
    </div>
    <div class="col-12 client" *ngFor="let item of listAssessorClient" (click)="selecClient(item)">
      <div class="row">
        <div class="col-7 border-r">
          <div class="name">{{ item.full_name | uppercase }}</div>
          <div class="profile">Perfil:
            <span class="bold blue" [ngClass]="{ 'yellow': item.profile_name === 'Moderado', 'purple': item.profile_name === 'Balanceado',
              'orange': item.profile_name === 'Arrojado', 'red': item.profile_name === 'Agressivo' }">
              {{ item.profile_name ? (item.profile_name | uppercase) : ('Não encontrado' | uppercase) }}
            </span>
          </div>
          <div class="profile">Email:<span class="bold">{{ item.email ? item.email : '-' }}</span></div>
          <div class="profile">Grupo:<span class="bold">{{ item.office_name ? item.office_name : '-' }}</span></div>
        </div>
        <div class="col-2 profile">
          <div class="col-12">Conta:</div>
          <div class="col-12 bold">{{ item.account }}</div>
        </div>
        <div class="col-3 profile">
          <div class="col-12">Telefone:</div>
          <div class="col-12 bold">{{ item.phone }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
